var React = require('react');

function SReportAbuse18 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.235,3.154a.547.547,0,0,1-.652-.542V1.8a.543.543,0,0,0-.407-.53A9.748,9.748,0,0,0,9.875,1,9.57707,9.57707,0,0,0,5,2.324V9.907A9.55,9.55,0,0,1,9.88,8.583a.547.547,0,0,1,.536.55V11a.5.5,0,0,0,.7.454,6.92435,6.92435,0,0,1,5.258-.717A.5.5,0,0,0,17,10.256V3.7a.5.5,0,0,0-.375-.49c-.7634-.18811-.54676-.28314-1.333-.283A9.50006,9.50006,0,0,0,13.235,3.154Z","fill":"var(--iconFill, #6e6e6e)","key":0}),React.createElement("rect",{"x":"2","y":"1","width":"2","height":"16","rx":"0.25","fill":"var(--iconFill, #6e6e6e)","key":1})]);
}

SReportAbuse18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SReportAbuse18;

SReportAbuse18.default = SReportAbuse18;
